<template>
  <div>
    <v-snackbar
      :value="snackbarOpenFlg"
      @input="close"
      :color="snackbarColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackbarMessage }}
      <v-btn :color="snackbarTextColor" flat @click="close"> 閉じる </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { actions, getters } from '@/vuex/modules/ui/snackbar/constants'
export default {
  data() {
    return {
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000,
    }
  },
  methods: {
    close() {
      this.$store.dispatch(actions.CLOSE_SNACKBAR)
    },
  },
  computed: {
    snackbarOpenFlg() {
      return this.$store.getters[getters.openFlag]
    },
    snackbarMessage() {
      return this.$store.getters[getters.message]
    },
    snackbarColor() {
      return this.$store.getters[getters.color]
    },
    snackbarTextColor() {
      return this.$store.getters[getters.textColor]
    },
  },
}
</script>
